import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Platforms } from "./components/Platforms";
import { Methodology } from "./components/Methodology";
import { Experience } from "./components/Experience";
import { Blogs } from "./components/Blogs";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import AdminInquiries from "./pages/AdminInquiries";
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LandingPage = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    fetch(`${BACKEND_URL}/api/visits`, { method: "POST" }).catch(() => {});
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div dir="rtl" className="grain bg-[#060B19] text-[#F8FAFC] min-h-screen font-body" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Platforms />
        <Methodology />
        <Experience />
        <Blogs />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors dir="rtl" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/barah-inquiries" element={<AdminInquiries />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
